import React, { useState } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import frLocale from "@fullcalendar/core/locales/fr";
import { Modal, Button } from "react-bootstrap";
import RdvDetails from "./RdvDetails";

export const CalendarView = ({ rdvs, onDeleteRequest }) => {
  const [selectedRdv, setSelectedRdv] = useState(null);
  const events = rdvs.map((rdv) => ({
    id: rdv.id.toString(), // toujours string pour FullCalendar
    title: `${rdv.client_nom} ${rdv.client_prenom}`,
    start: rdv.date_prise_rdv,
    allDay: false,
  }));

  const handleEventClick = (info) => {
    const clickedRdv = rdvs.find((r) => r.id.toString() === info.event.id);
    if (clickedRdv) {
      setSelectedRdv(clickedRdv);
    }
  };

  const isDark = document.body.getAttribute("data-bs-theme") === "dark";

  return (
    <div className="p-4">
      <FullCalendar
        themeSystem="standard"
        className={isDark ? "fc-dark" : "fc-light"}
        plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
        locale={frLocale}
        initialView="dayGridMonth"
        // slotMinTime="06:00:00"
        // slotMaxTime="20:00:00"
        headerToolbar={{
          left: "prev,next today",
          center: "title",
          right: "",
        }}
        events={events}
        eventClick={handleEventClick}
        height="auto"
      />

      {selectedRdv && (
        <Modal show onHide={() => setSelectedRdv(null)} centered size="xl">
          <Modal.Header closeButton>
            <Modal.Title>Détails du rendez-vous</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <RdvDetails rdv={selectedRdv} />{" "}
            {/* Utilisation du composant RdvDetails */}
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="danger"
              onClick={() => {
                setSelectedRdv(null);
                onDeleteRequest(selectedRdv);
              }}
            >
              Supprimer
            </Button>
            <Button variant="secondary" onClick={() => setSelectedRdv(null)}>
              Fermer
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </div>
  );
};
